import host from './host.js';
import request from '@/utils/request.js';
import qs from 'qs';

const user = {
    login( params )
    { //用户登录
        return request.post( host.test + '/Kitchen/KitchenUser/Login', params );
    },
    regist( params )
    { //用户注册
        return request.post( host.test + '/Kitchen/KitchenUser/Register', params );
    },
    changeTrueName( params )
    { //修改真实姓名
        return request.post( host.test + '/Kitchen/KitchenUser/ChangeTrueName', params );
    },
    retrievePassword( params )
    { //找回密码
        return request.post( host.test + '/Kitchen/KitchenUser/ChangePassword', params );
    },
    sendCode( params )
    { //发送验证码
        return request.post( host.test + '/Kitchen/KitchenUser/SendCode', params )
    },
    bankList()
    { // 银行列表
        return request.post( host.test + '/Kitchen/Bank/GetBankList', '' )
    },
    bankAdd( params )
    { // 添加银行卡
        return request.post( host.test + '/Kitchen/KitchenUser/AddUserBankCard', params )
    },
    BuyVip( params )
    { // 购买会员
        return request.post( host.test + '/Kitchen/KitchenUser/BuyVip', params )
    },
    ChangePassword( params )
    { // 修改密码
        return request.post( host.test + '/Kitchen/KitchenUser/ChangePassword', params )
    },
    ChangePayPassword( params )
    { // 设置支付密码
        return request.post( host.test + '/Kitchen/KitchenUser/ChangePayPassword', params )
    },
    GetUserInfo()
    { // 获取用户信息
        return request.post( host.test + '/Kitchen/KitchenUser/GetUserInfo', '' )
    },
    




}

export default user;